export default [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Portuguese',
    code: 'pt-BR',
  },
  {
    name: 'Spanish',
    code: 'es',
  },
];
